import { render } from "./multiChoice.vue?vue&type=template&id=7d7b795c&scoped=true"
import script from "./multiChoice.vue?vue&type=script&lang=js"
export * from "./multiChoice.vue?vue&type=script&lang=js"

import "./multiChoice.vue?vue&type=style&index=0&id=7d7b795c&scoped=true&lang=css"
import "./multiChoice.vue?vue&type=style&index=1&id=7d7b795c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7b795c"]])

export default __exports__